import React, { Component } from 'react';

class WithStorePreviusSelected extends Component {
  render() {
    const { storeNearSelected } = this.props;
    return (
      <div className="withStorePreviusSelected alignmentRow">
        <span>Mi tienda</span>
        <span> - </span>
        <span>{storeNearSelected}</span>
      </div>
    );
  }
}

export default WithStorePreviusSelected;
